export interface selectItemType {
	value: string | null;
	label: string;
}

export const nationalities: selectItemType[] = [
	{ value: 'Afghan', label: 'Afghan' },
	{ value: 'Albanian', label: 'Albanian' },
	{ value: 'Algerian', label: 'Algerian' },
	{ value: 'American', label: 'American' },
	{ value: 'Andorran', label: 'Andorran' },
	{ value: 'Angolan', label: 'Angolan' },
	{ value: 'Antiguans', label: 'Antiguans' },
	{ value: 'Argentinean', label: 'Argentinean' },
	{ value: 'Armenian', label: 'Armenian' },
	{ value: 'Australian', label: 'Australian' },
	{ value: 'Austrian', label: 'Austrian' },
	{ value: 'Azerbaijani', label: 'Azerbaijani' },
	{ value: 'Bahamian', label: 'Bahamian' },
	{ value: 'Bahraini', label: 'Bahraini' },
	{ value: 'Bangladeshi', label: 'Bangladeshi' },
	{ value: 'Barbadian', label: 'Barbadian' },
	{ value: 'Barbudans', label: 'Barbudans' },
	{ value: 'Batswana', label: 'Batswana' },
	{ value: 'Belarusian', label: 'Belarusian' },
	{ value: 'Belgian', label: 'Belgian' },
	{ value: 'Belizean', label: 'Belizean' },
	{ value: 'Beninese', label: 'Beninese' },
	{ value: 'Bhutanese', label: 'Bhutanese' },
	{ value: 'Bolivian', label: 'Bolivian' },
	{ value: 'Bosnian', label: 'Bosnian' },
	{ value: 'Brazilian', label: 'Brazilian' },
	{ value: 'British', label: 'British' },
	{ value: 'Bruneian', label: 'Bruneian' },
	{ value: 'Bulgarian', label: 'Bulgarian' },
	{ value: 'Burkinabe', label: 'Burkinabe' },
	{ value: 'Burmese', label: 'Burmese' },
	{ value: 'Burundian', label: 'Burundian' },
	{ value: 'Cambodian', label: 'Cambodian' },
	{ value: 'Cameroonian', label: 'Cameroonian' },
	{ value: 'Canadian', label: 'Canadian' },
	{ value: 'Cape Verdean', label: 'Cape Verdean' },
	{ value: 'Central African', label: 'Central African' },
	{ value: 'Chadian', label: 'Chadian' },
	{ value: 'Chilean', label: 'Chilean' },
	{ value: 'Chinese', label: 'Chinese' },
	{ value: 'Colombian', label: 'Colombian' },
	{ value: 'Comoran', label: 'Comoran' },
	{ value: 'Congolese', label: 'Congolese' },
	{ value: 'Costa Rican', label: 'Costa Rican' },
	{ value: 'Croatian', label: 'Croatian' },
	{ value: 'Cuban', label: 'Cuban' },
	{ value: 'Cypriot', label: 'Cypriot' },
	{ value: 'Czech', label: 'Czech' },
	{ value: 'Danish', label: 'Danish' },
	{ value: 'Djibouti', label: 'Djibouti' },
	{ value: 'Dominican', label: 'Dominican' },
	{ value: 'Dutch', label: 'Dutch' },
	{ value: 'East Timorese', label: 'East Timorese' },
	{ value: 'Ecuadorean', label: 'Ecuadorean' },
	{ value: 'Egyptian', label: 'Egyptian' },
	{ value: 'Emirian', label: 'Emirian' },
	{ value: 'Equatorial Guinean', label: 'Equatorial Guinean' },
	{ value: 'Eritrean', label: 'Eritrean' },
	{ value: 'Estonian', label: 'Estonian' },
	{ value: 'Ethiopian', label: 'Ethiopian' },
	{ value: 'Fijian', label: 'Fijian' },
	{ value: 'Filipino', label: 'Filipino' },
	{ value: 'Finnish', label: 'Finnish' },
	{ value: 'French', label: 'French' },
	{ value: 'Gabonese', label: 'Gabonese' },
	{ value: 'Gambian', label: 'Gambian' },
	{ value: 'Georgian', label: 'Georgian' },
	{ value: 'German', label: 'German' },
	{ value: 'Ghanaian', label: 'Ghanaian' },
	{ value: 'Greek', label: 'Greek' },
	{ value: 'Grenadian', label: 'Grenadian' },
	{ value: 'Guatemalan', label: 'Guatemalan' },
	{ value: 'Guinea-Bissauan', label: 'Guinea-Bissauan' },
	{ value: 'Guinean', label: 'Guinean' },
	{ value: 'Guyanese', label: 'Guyanese' },
	{ value: 'Haitian', label: 'Haitian' },
	{ value: 'Herzegovinian', label: 'Herzegovinian' },
	{ value: 'Honduran', label: 'Honduran' },
	{ value: 'Hungarian', label: 'Hungarian' },
	{ value: 'Icelander', label: 'Icelander' },
	{ value: 'Indian', label: 'Indian' },
	{ value: 'Indonesian', label: 'Indonesian' },
	{ value: 'Iranian', label: 'Iranian' },
	{ value: 'Iraqi', label: 'Iraqi' },
	{ value: 'Irish', label: 'Irish' },
	{ value: 'Israeli', label: 'Israeli' },
	{ value: 'Italian', label: 'Italian' },
	{ value: 'Ivorian', label: 'Ivorian' },
	{ value: 'Jamaican', label: 'Jamaican' },
	{ value: 'Japanese', label: 'Japanese' },
	{ value: 'Jordanian', label: 'Jordanian' },
	{ value: 'Kazakhstani', label: 'Kazakhstani' },
	{ value: 'Kenyan', label: 'Kenyan' },
	{ value: 'Kuwaiti', label: 'Kuwaiti' },
	{ value: 'Kyrgyz', label: 'Kyrgyz' },
	{ value: 'Laotian', label: 'Laotian' },
	{ value: 'Latvian', label: 'Latvian' },
	{ value: 'Lebanese', label: 'Lebanese' },
	{ value: 'Liberian', label: 'Liberian' },
	{ value: 'Libyan', label: 'Libyan' },
	{ value: 'Liechtensteiner', label: 'Liechtensteiner' },
	{ value: 'Lithuanian', label: 'Lithuanian' },
	{ value: 'Luxembourger', label: 'Luxembourger' },
	{ value: 'Macedonian', label: 'Macedonian' },
	{ value: 'Malagasy', label: 'Malagasy' },
	{ value: 'Malawian', label: 'Malawian' },
	{ value: 'Malaysian', label: 'Malaysian' },
	{ value: 'Maldivan', label: 'Maldivan' },
	{ value: 'Malian', label: 'Malian' },
	{ value: 'Maltese', label: 'Maltese' },
	{ value: 'Marshallese', label: 'Marshallese' },
	{ value: 'Mauritanian', label: 'Mauritanian' },
	{ value: 'Mauritian', label: 'Mauritian' },
	{ value: 'Mexican', label: 'Mexican' },
	{ value: 'Micronesian', label: 'Micronesian' },
	{ value: 'Moldovan', label: 'Moldovan' },
	{ value: 'Monacan', label: 'Monacan' },
	{ value: 'Mongolian', label: 'Mongolian' },
	{ value: 'Moroccan', label: 'Moroccan' },
	{ value: 'Mosotho', label: 'Mosotho' },
	{ value: 'Motswana', label: 'Motswana' },
	{ value: 'Mozambican', label: 'Mozambican' },
	{ value: 'Namibian', label: 'Namibian' },
	{ value: 'Nauruan', label: 'Nauruan' },
	{ value: 'Nepalese', label: 'Nepalese' },
	{ value: 'New Zealander', label: 'New Zealander' },
	{ value: 'Ni-Vanuatu', label: 'Ni-Vanuatu' },
	{ value: 'Nicaraguan', label: 'Nicaraguan' },
	{ value: 'Nigerien', label: 'Nigerien' },
	{ value: 'North Korean', label: 'North Korean' },
	{ value: 'Northern Irish', label: 'Northern Irish' },
	{ value: 'Norwegian', label: 'Norwegian' },
	{ value: 'Omani', label: 'Omani' },
	{ value: 'Pakistani', label: 'Pakistani' },
	{ value: 'Palauan', label: 'Palauan' },
	{ value: 'Panamanian', label: 'Panamanian' },
	{ value: 'Papua New Guinean', label: 'Papua New Guinean' },
	{ value: 'Paraguayan', label: 'Paraguayan' },
	{ value: 'Peruvian', label: 'Peruvian' },
	{ value: 'Polish', label: 'Polish' },
	{ value: 'Portuguese', label: 'Portuguese' },
	{ value: 'Qatari', label: 'Qatari' },
	{ value: 'Romanian', label: 'Romanian' },
	{ value: 'Russian', label: 'Russian' },
	{ value: 'Rwandan', label: 'Rwandan' },
	{ value: 'Saint Lucian', label: 'Saint Lucian' },
	{ value: 'Salvadoran', label: 'Salvadoran' },
	{ value: 'Samoan', label: 'Samoan' },
	{ value: 'San Marinese', label: 'San Marinese' },
	{ value: 'Sao Tomean', label: 'Sao Tomean' },
	{ value: 'Saudi', label: 'Saudi' },
	{ value: 'Scottish', label: 'Scottish' },
	{ value: 'Senegalese', label: 'Senegalese' },
	{ value: 'Serbian', label: 'Serbian' },
	{ value: 'Seychellois', label: 'Seychellois' },
	{ value: 'Sierra Leonean', label: 'Sierra Leonean' },
	{ value: 'Singaporean', label: 'Singaporean' },
	{ value: 'Slovakian', label: 'Slovakian' },
	{ value: 'Slovenian', label: 'Slovenian' },
	{ value: 'Solomon Islander', label: 'Solomon Islander' },
	{ value: 'Somali', label: 'Somali' },
	{ value: 'south South African', label: 'south South African' },
	{ value: 'south South Korean', label: 'south South Korean' },
	{ value: 'Spanish', label: 'Spanish' },
	{ value: 'Sri Lankan', label: 'Sri Lankan' },
	{ value: 'Sudanese', label: 'Sudanese' },
	{ value: 'Surinamer', label: 'Surinamer' },
	{ value: 'Swazi', label: 'Swazi' },
	{ value: 'Swedish', label: 'Swedish' },
	{ value: 'Swiss', label: 'Swiss' },
	{ value: 'Syrian', label: 'Syrian' },
	{ value: 'Taiwanese', label: 'Taiwanese' },
	{ value: 'Tajik', label: 'Tajik' },
	{ value: 'Tanzanian', label: 'Tanzanian' },
	{ value: 'Thai', label: 'Thai' },
	{ value: 'Togolese', label: 'Togolese' },
	{ value: 'Tongan', label: 'Tongan' },
	{ value: 'Tunisian', label: 'Tunisian' },
	{ value: 'Turkish', label: 'Turkish' },
	{ value: 'Tuvaluan', label: 'Tuvaluan' },
	{ value: 'Ugandan', label: 'Ugandan' },
	{ value: 'Ukrainian', label: 'Ukrainian' },
	{ value: 'Uruguayan', label: 'Uruguayan' },
	{ value: 'Uzbekistani', label: 'Uzbekistani' },
	{ value: 'Venezuelan', label: 'Venezuelan' },
	{ value: 'Vietnamese', label: 'Vietnamese' },
	{ value: 'Welsh', label: 'Welsh' },
	{ value: 'Yemenite', label: 'Yemenite' },
	{ value: 'Zambian', label: 'Zambian' },
	{ value: 'Zimbabwean', label: 'Zimbabwean' },
];
